import * as Long from "long";
import { from } from "rxjs";
import { actionInventoryInfoAddResource } from "../../info/inventory/actionInventoryInfo";
import { actionBuyProductConfirmed } from "../actionTrade";
export var pathBuyProduct = function (action, state$, deps) {
    var income = [
        {
            amount: Long.fromNumber(action.amount),
            typeId: action.itemId,
        },
    ];
    return from([
        actionInventoryInfoAddResource(income),
        actionBuyProductConfirmed(action.itemId, action.amount),
    ]);
};



//////////////////
// WEBPACK FOOTER
// ./src/features/trade-component/paths/pathBuyProduct.ts
// module id = 2451
// module chunks = 3